import { TFunction } from "react-i18next";
import * as Yup from "yup";

export const requiredPositiveNumber = (t: TFunction) =>
  Yup.number()
    .required(t("generic:validation-required"))
    .moreThan(0, t("generic:must-be-positive-number"));
